import {initializeMediaUpload} from "./utility/media-uploader";
import {initializeFormSubmission} from "./utility/form-submission";
import {generateProductSlug} from "./utility/helper"; // Import the form submission function

document.addEventListener('DOMContentLoaded', function () {
    let uploadButton: HTMLElement | null;

    const AmbiklyCategory = {
        init: function () {
            this.handleMediaUpload();
            initializeFormSubmission(); // Call the imported form submission function
            this.bindSlugEvent();

        },
        handleMediaUpload: function () {
            const uploadButtons = document.querySelectorAll('.ambikly-image-upload');
            (uploadButtons as NodeListOf<HTMLElement>).forEach((button) => {
                button.addEventListener('click', (e: MouseEvent) => {
                    e.preventDefault();
                    uploadButton = e.currentTarget as HTMLElement;
                    initializeMediaUpload(uploadButton);
                });
            });
        },
        bindSlugEvent: function () {

            const categoryNameInput = document.querySelector('input[name="category_name"]') as HTMLInputElement;
            const categorySlugInput = document.querySelector('input[name="category_slug"]') as HTMLInputElement;
            if (categoryNameInput) {
                categoryNameInput.addEventListener('input', () => {
                    const categoryName = categoryNameInput.value;
                    const slug = generateProductSlug(categoryName);
                    if (categorySlugInput) {
                        categorySlugInput.value = slug; // Set slug in category_slug input
                    }
                });
            }
        },
    };

    AmbiklyCategory.init();
});
